"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYOUT_SESSION = exports.REFUND_PROCESSING_DAYS = exports.BALANCE_THRESHOLD_SMALL_POSITIVE = exports.BALANCE_THRESHOLD_LARGE_POSITIVE = exports.MIN_DD_AMOUNT = exports.MAX_DD_AMOUNT = void 0;
exports.MAX_DD_AMOUNT = 2000;
exports.MIN_DD_AMOUNT = 5;
exports.BALANCE_THRESHOLD_LARGE_POSITIVE = 50;
exports.BALANCE_THRESHOLD_SMALL_POSITIVE = 5;
exports.REFUND_PROCESSING_DAYS = '10';
exports.PAYOUT_SESSION = 'payoutAccounts';
